import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from '@infrastructure/shared/theme/layout';
import { Page404Component } from '@infrastructure/pages/pages/page404/page404.component';
import { Page500Component } from '@infrastructure/pages/pages/page500/page500.component';
import { NuevoSocioComponent } from '@infrastructure/pages/catalog/socios/nuevo-socio/nuevo-socio.component';
import { AutorizaLiquidacionesComponent } from '@infrastructure/pages/proceso/autoriza-liquidaciones/autoriza-liquidaciones.component';
import { ConsultaLiquidacionConceptoComponent } from '@infrastructure/pages/proceso/consulta-liquidacion-concepto/consulta-liquidacion-concepto.component';
import { ConsultaLiquidacionConsecutivoComponent } from '@infrastructure/pages/proceso/consulta-liquidacion-consecutivo/consulta-liquidacion-consecutivo.component';
import { ConsultaLiquidacionPreviaComponent } from '@infrastructure/pages/proceso/consulta-liquidacion-previa/consulta-liquidacion-previa.component';
import { ConsultaLiquidacionDefinitivaComponent } from '@infrastructure/pages/proceso/consulta-liquidacion-definitiva/consulta-liquidacion-definitiva.component';
import { CalculaLiquidacionComponent } from '@infrastructure/pages/proceso/calcula-liquidacion/calcula-liquidacion.component';
import { TransferenciaUnionCreditoComponent } from '@infrastructure/pages/proceso/transferencia-union-credito/transferencia-union-credito.component';
import { ControlInternoComponent } from '@infrastructure/pages/proceso/control-interno/control-interno.component';
import { ReversaLiquidacionComponent } from '@infrastructure/pages/captura/reversa-liquidacion/reversa-liquidacion.component';
import { CierreSemanalComponent } from '@infrastructure/pages/proceso/cierre-semanal/cierre-semanal.component';
import { AuthInterceptor } from '@infrastructure/interceptors/auth.interceptor';
import { LoginComponent } from '@infrastructure/shared/theme/login/login.component';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CustomHeaderInterceptor } from '@infrastructure/interceptors/CustomHeaderInterceptor';import { ImpresionLiquidacionService } from '@domain/services/reportes/impresion-liquidacion.service';
import { CalculaLiquidacionService } from '@infrastructure/pages/reportes/calcula-liquidacion.service';
import { DatesService } from '@infrastructure/services/alpura/dates.service';
import { PartnerService } from '@infrastructure/services/alpura/partner.service';
import { PlantasService } from '@infrastructure/services/catalog/plantas.service';
import { UtilInformationService } from '@infrastructure/services/utils/dates.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home',
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('@infrastructure/pages/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
        canActivate: [AuthInterceptor],
      },

      {
        path: 'catalog',
        loadChildren: () =>
          import('@infrastructure/pages/catalog/catalog.module').then(
            (m) => m.CatalogdModule
          ),
        canActivate: [AuthInterceptor],
      },
      {
        path: 'Captura',
        loadChildren: () =>
          import('@infrastructure/pages/captura/captura.module').then(
            (m) => m.CapturaModule
          ),
        canActivate: [AuthInterceptor],
      },
      {
        path: 'Reportes',
        loadChildren: () =>
          import('@infrastructure/pages/reportes/reportes.module').then(
            (m) => m.ReportesModule
          ),
        canActivate: [AuthInterceptor],
      },
      {
        path: 'mantenimiento',
        loadChildren: () =>
          import(
            '@infrastructure/pages/mantenimiento/mantenimiento.module'
          ).then((m) => m.MantenimientoModule),
        canActivate: [AuthInterceptor],
      },
      {
        path: 'liquidacion',
        loadChildren: () =>
          import(
            '@infrastructure/pages/liquidacion/liquidacion.module'
          ).then((m) => m.LiquidacionModule),
        canActivate: [AuthInterceptor],
      },
      {
        path: 'pages',
        loadChildren: () =>
          import('@infrastructure/pages/pages/pages.module').then(
            (m) => m.PagesModule
          ),
        canActivate: [AuthInterceptor],
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('@infrastructure/pages/settings/settings.module').then(
            (m) => m.SettingsModule
          ),
        canActivate: [AuthInterceptor],
      },
      {
        path: 'reporte',
        loadChildren: () =>
          import('@infrastructure/pages/reportes/reportes.module').then(
            (m) => m.ReportesModule
          ),
        canActivate: [AuthInterceptor],
      },
      {
        path: 'contabilidad',
        loadChildren: () =>
          import('@infrastructure/pages/contabilidad/contabilidad.module').then(
            (m) => m.ContabilidadModule
          ),
        canActivate: [AuthInterceptor],
      },

      {
        path: 'catalog/nuevo-socio/:num',
        component: NuevoSocioComponent,
        data: {
          title: $localize`Actualizar Socio`,
        },
        canActivate: [AuthInterceptor],
      },
      {
        path: 'capturas',
        loadChildren: () =>
          import('@infrastructure/pages/capturas/capturas.module').then(
            (m) => m.CapturasModule
          ),
        canActivate: [AuthInterceptor],
      },
      {
        path: 'calidad',
        loadChildren: () =>
          import('@infrastructure/pages/calidad/calidad.module').then(
            (m) => m.CalidadModule
          ),
        canActivate: [AuthInterceptor],
      },
      {
        path: 'procesos',
        loadChildren: () =>
          import('@infrastructure/pages/proceso/proceso.module').then(
            (m) => m.ProcesoModule
          ),
        canActivate: [AuthInterceptor],
      },
    ],
    canActivate: [AuthInterceptor],
  },
  {
    path: 'pages',
    loadChildren: () =>
      import('@infrastructure/pages/pages.module').then((m) => m.PagesModule),
    canActivate: [AuthInterceptor],
  },
  {
    path: '404',
    component: Page404Component,
    data: {
      title: 'Page 404',
    },
  },
  {
    path: '500',
    component: Page500Component,
    data: {
      title: 'Page 500',
    },
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Validation Login',
    },
  },
  {
    path: 'state',
    redirectTo: 'login',
    pathMatch: 'full',
  },
{
  path: 'reco',
  loadChildren: () =>
    import('@infrastructure/pages/reco/reco.module').then(m => m.RecoModule),
  canActivate: [AuthInterceptor], // ← sigue protegido
},
  { path: '**', component: LoginComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
      relativeLinkResolution: 'legacy',
      preloadingStrategy: PreloadAllModules,
      useHash: true,
    }),
  ],
  exports: [RouterModule, HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHeaderInterceptor,
      multi: true,
    },
    UtilInformationService,
    DatesService,
    PlantasService,
    PartnerService,
    CalculaLiquidacionService,
    ImpresionLiquidacionService,
    PartnerService,
  ]
})
export class AppRoutingModule {}
